(function () {
  if (window.floralQuickAddBound) return;
  window.floralQuickAddBound = true;

  const addToCart = async (variantId, button) => {
    if (!variantId) return;
    if (button) button.classList.add('is-loading');
    try {
      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (window.theme && theme.miniCart) {
        theme.miniCart.updateElements();
        theme.miniCart.generateCart();
      }
      const mini = document.querySelector('.js-mini-cart');
      if (mini) mini.classList.add('active');
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-floral-quick-add]');
    if (button) {
      event.preventDefault();
      if (button.dataset.hasVariants === 'true') {
        const dialog = button.parentElement.querySelector('[data-floral-variant-dialog]');
        if (dialog) dialog.showModal();
      } else {
        addToCart(button.dataset.variantId, button);
      }
      return;
    }

    const closer = event.target.closest('[data-floral-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-floral-variant-form]');
    if (!form) return;
    event.preventDefault();
    const select = form.querySelector('select[name="id"]');
    const dialog = form.closest('dialog');
    addToCart(select && select.value, form.querySelector('[type="submit"]')).then(() => {
      if (dialog) dialog.close();
    });
  });
})();
